export default __webpack_public_path__ + "static/media/listbuilder-star-selected.701ffb67.svg";